// Leer las respuestas de las preguntas, que pueden ser varias por pregunta
// (ADR-2026-10-02-onboarding-v2-preguntas-de-varias). Sin dependencias: lo usan el guardado
// (`marca.ts`), el ruteo (`canales.ts`) y las pantallas.

import type { RespuestasDeLaEspera } from './marca';

/**
 * Todo lo que respondió en una pregunta, en el orden en que lo marcó. Sin `todas` (un estado
 * de antes, o el respaldo del tablero, que sigue de a una), es la principal sola.
 */
export function respuestasDe(r: RespuestasDeLaEspera | undefined, clave: 'primero' | 'rol' | 'anunciosPagos' | 'canal'): string[] {
  const todas = r?.todas?.[clave];
  if (todas?.length) return todas;
  const una = r?.[clave];
  return una ? [una] : [];
}
